<div class="history-wrapper container-fluid py-4">

  <!-- TABS -->
  <div class="d-flex justify-content-center mb-4">
    <div class="lux-tabs">
      <button
        [class.active]="step === 1"
        (click)="step = 1">
        Deposits
      </button>

      <button
        [class.active]="step === 2"
        (click)="step = 2">
        Withdrawals
      </button>
    </div>
  </div>


  <!-- DEPOSITS -->
  <div *ngIf="step === 1">

    <div *ngIf="dep.length > 0; else noDeposit">
      <div class="lux-card" *ngFor="let item of dep">

        <div class="lux-left">
          <div class="gold-dot"></div>
        </div>

        <div class="lux-content">
          <div class="lux-title" style="text-transform: uppercase;">
            {{ item.username }} Purchased Gold  {{ item.plan }}
          </div>

          <div class="lux-amount">
            ${{ item.amount | number }}
          </div>


          <div class="lux-profit">
            Expected ROI: ${{ item.expected_roi | number }}
          </div>

          <div class="lux-date">
            {{ item.depositDate }}
          </div>
        </div>

      </div>
    </div>

    <ng-template #noDeposit>
      <div class="lux-empty">
        No Deposits Yet
      </div>
    </ng-template>

  </div>


  <!-- WITHDRAWALS -->
  <div *ngIf="step === 2">

    <div *ngIf="with.length > 0; else noWithdraw">
      <div class="lux-card withdraw" *ngFor="let item of with">

        <div class="lux-left">
          <div class="silver-dot"></div>
        </div>

        <div class="lux-content">
          <div class="lux-title">
            {{ item.username }} withdrew
          </div>

          <div class="lux-amount">
            ${{ item.withdrawamount | number }}
          </div>

          <div class="lux-date">
            {{ item.date }}
          </div>
        </div>

      </div>
    </div>

    <ng-template #noWithdraw>
      <div class="lux-empty">
        No Withdrawals Yet
      </div>
    </ng-template>

  </div>

</div>
